// @flow
import styled from 'styled-components';

export const ActionContainer = styled.div`padding: 2em;`;

export const Line = styled.hr`
    border: none;
    border-bottom: solid 1px ${p => p.theme.secondaryLight};
    margin: 0.7em 0;
`;

export const Section = styled.div`
    align-items: center;
    display: flex;
    height: 2.3em;

    & > *:first-child {
        flex: 1 0 auto;
    }
`;

export const EditIconContainer = styled.div`
    cursor: pointer;
    flex: 0 0 2.5em;
    padding: 0.6em;
`;

export const ActionNameInput = styled.input`
    background-color: ${p => p.theme.secondaryLight};
    border: solid 1px ${p => p.theme.mediumGrey};
    border-radius: 1em;
    height: 3em;
    padding-left: 1em;
    width: 100%;
`;

export const ToggleContainer = styled.div`
    flex: 0 0 2.5em;
    padding: 0.6em;

    & > * {
        font-size: 0.7em;
    }
`;

export const EventTitle = styled.div`margin: 1.5em 0 0.2em;`;

export const Remove = styled.div`
    align-items: center;
    cursor: pointer;
    color: ${p => p.theme.mainBrandColor};
    display: flex;
    height: 2em;
    justify-content: center;
    transition: all 0.2s;

    &:hover {
        text-decoration: underline;
    }
`;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/action-detail/styles.js